import React, { useState, useEffect } from 'react'
import bgimg from '../global-images/startup3.jpeg'
import "../styles/contact.css";
import axios from 'axios';
function Contact() {
    // const add = '172.30.8.191'
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: '',
        phone: ''
    });
    const [isFormValid, setIsFormValid] = useState(false);
    const sendButton = document.getElementById("sendbutton")
    const handleChange = (e) => {
        const { name, value } = e.target;
        const updatedFormData = { ...formData, [e.target.name]: e.target.value };
        setFormData(updatedFormData);
        // setFormData(updatedFormData);
        setIsFormValid(validateForm(updatedFormData));
    };
    const validateForm = (data) => {
        return data.name && data.email && data.message && data.phone;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!isFormValid) {
            alert('Please fill out all fields.');
            return;
        }
        console.log('Form Data:', formData); // Log formData to check its content
        console.log('Submitting...');

        try {
            sendButton.innerText = "Sending..."
            const response = await axios.post(`http:172.30.8.123:5000/sendEmail`, formData);
            // const response = await axios.post("http://localhost:3000/sendEmail", formData);
            console.log('Response:', response.data); // Log the response from the server
            alert('Message was sent successfully!');
            setFormData({ name: '', email: '', message: '', phone: '' }); // Reset form data in state
            // sendButton.innerText = "Send";

        }
        catch (error) {
            alert('Failed to send message.');
            console.error('Error:', error);
        }
        finally {
            sendButton.innerText = "Send"
        }
    };
    // var formdata = new FormData();
    // formdata.append("akshit", "");

    // var requestOptions = {
    //     method: 'POST',
    //     body: formdata,
    //     redirect: 'follow'
    // };

    // fetch("http://localhost:5000/sendEmail", requestOptions)
    //     .then(response => response.text())
    //     .then(result => console.log(result))
    //     .catch(error => console.log('error', error));

    return (
        // <br></br>
        <div className='relative flex justify-center items-center' >
            <div class="area absolute inset-0 " >
                <ul class="circles">
                    <li></li><li></li><li></li><li></li><li></li><li></li><li></li><li></li><li></li><li></li><li></li><li></li>
                    <li></li><li></li><li></li><li></li><li></li><li></li><li></li><li></li><li></li><li></li>
                </ul>
            </div >

            <form className="form lg:w-3/4 sm:p-10  grid grid-cols-1 mt-20 sm:mt-24 mb-10 relative z-10 grid lg:grid-cols-2 sm:grid-cols-1" onSubmit={handleSubmit} id='ContactForm'>
                {/* <bg-image src={bgimg} alt="" /> */}
                <div className='p-4 lg:mx-3'>
                    <div className='text-white-800 font-mono sm:text-4xl font-bold title-font'>
                        {/* <h1> Contact Us</h1> */}
                    </div>
                    <div>
                        <img className='rounded-md' src={bgimg}></img>
                    </div>
                    <div className='font-montserrat p-3 text-justify'>
                        We're here to assist you! If you have any questions or need assistance, please feel free to reach out to us.
                    </div>
                </div>
                <div className='font-montserrat flex justify-center items-center'>
                    <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSebrTGymn_GMTmlj55L6qHh7nuu1Dbs3Oq3WqBieeGX_ErWWg/viewform?embedded=true"
                        frameborder="0"
                        marginheight="0"
                        marginwidth="0"
                        scrolling="no"
                        // height="880px"
                        className='lg:w-full md:w-full xs:w-full sm:w-full lg:h-[910px] md:h-[910px] sm:h-[900px] xs:h-[920px]'>

                        Loading…
                    </iframe>
                    {/* <div className="flex flex-wrap -mx-3 mb-6">
                        <div className="w-full md:w-1/2 sm:w-1/3 px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-white text-xs font-bold mb-2" htmlFor="grid-first-name" value={formData.name}>
                                Name
                            </label>
                            <input className="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" id="grid-first-name"
                                type="text"
                                placeholder="Your Name"
                                name="name"
                                value={formData.name}
                                required
                                onChange={handleChange} />
                        </div>
                        <div className="w-full md:w-1/2 px-3">
                            <label className="block uppercase tracking-wide text-white  text-xs font-bold mb-2" htmlFor="Phone number" value={formData.phone}>
                                Phone Number
                            </label>
                            <input className="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                                id="phone"
                                type='number'
                                name="phone"
                                required
                                placeholder="Your Phone Number"
                                value={formData.phone}
                                onChange={handleChange} />
                        </div>
                    </div>
                    <div className="flex flex-wrap -mx-3 mb-6">
                        <div className="w-full px-3">
                            <label className="block uppercase tracking-wide text-white  text-xs font-bold mb-2" htmlFor="grid-password" value={formData.email}>
                                Email
                            </label>
                            <input className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                id="email"
                                type="email"
                                name="email"
                                required
                                placeholder="Your Email"
                                value={formData.email}
                                onChange={handleChange} />
                        </div>
                    </div>
                    <div className="flex flex-wrap -mx-3 mb-6">
                        <div className="w-full px-3">
                            <label className="block uppercase tracking-wide text-white  text-xs font-bold mb-2" htmlFor="message" value={formData.message}>
                                Message
                            </label>
                            <textarea className=" no-resize appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-48 resize-none"
                                id="message"
                                type='message'
                                name='message'
                                required
                                placeholder="Your message..."
                                value={formData.message}
                                onChange={handleChange}
                            >
                            </textarea>
                        </div>
                    </div>
                    <div className="flex justify-center items-center ">
                        <div className="md:w-1/3 items-center flex justify-center">
                            <div class="relative inline-flex group">
                                <div
                                    class="absolute transitiona-all duration-1000 opacity-70 -inset-px bg-gradient-to-r from-[#6B46C1] via-[#FF44EC] to-[#6B46C1] blur-lg group-hover:opacity-100 group-hover:-inset-1 group-hover:duration-200 animate-tilt">
                                </div>
                                <button  title="Get quote now"
                                id="sendbutton"
                                    class="relative inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white transition-all duration-200 bg-purple-900 font-pj focus:outline-none rounded-lg focus:ring-2 focus:ring-offset-2 focus:ring-white"
                                    type='submit'
                                    disabled={!isFormValid}
                                    onClick={handleSubmit}
                                    role="button">Send
                                </button>
                            </div>
                        </div>
                    </div> */}
                </div>
            </form>
        </div>
    )
}

export default Contact
